<template>
<transition name="modal">
    <div class="modal-mask">
        <div class="modal-wrapper" @click.stop="click">
            <div class="modal-container" :style="modalWidth" @click.stop="none">
                <div class="modal-header">
                    <slot name="header">
                    </slot>
                </div>
                <div class="modal-body">
                    <slot name="body">
                    </slot>
                </div>
                <div class="modal-footer">
                    <slot name="footer">
                    </slot>
                </div>
            </div>
        </div>
    </div>
</transition>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    width: {
      type: String,
      default: function() {
        return "600";
      }
    }
  },
  computed: {
    modalWidth: function() { return"max-width:" + this.width + "px"}
  },
  methods: {
    click: function() {
      this.$emit('click')
    },
    none: function() {
      // serve per prevenire la chiusura del modale se clicco nel dialog
    }
  }
}
</script>

<style scoped>

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: block;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.modal-container {
  overflow: auto;
  width: auto;
  margin: 10px auto;
  background-color: var(--background-color);
  border-radius: 18px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

@media screen and (max-width: 800px) {
  .modal-container {
    max-width: 100% !important;
  }
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 0 0;
  padding: 10px;
  overflow: auto;
  max-height: 700px;
}

.modal-footer {
  padding: 10px;
}

.modal-default-button {
  float: right;
}

/*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    *
    * You can easily play with the modal transition by editing
    * these styles.
    */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@media screen and (max-width: 720px) {
  .modal-container {
    margin: 10px;
    /* max-height: 700px; */
  }
  .modal-body {
    max-height: 80%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/utils/Modal.vue